module.exports = "<div class=\"footer\">\n  <p>\n    <span class=\"links\"\n      ><a class=\"link\" href=\"\" target=\"_blank\" [routerLink]=\"'/impressum'\"\n        >Impressum</a\n      >\n      |\n      <a class=\"link\" href=\"\" target=\"_blank\" [routerLink]=\"'/privacy'\"\n        >Datenschutz</a\n      >\n    </span>\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = main